import React, { Component } from 'react';
import {
  compact,
  flattenDeep,
  get,
  includes,
  indexOf,
  isEqual,
  keys,
  map,
  reduce,
  times,
  uniqWith,
} from 'lodash';
import confirm from 'react-confirm2';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import displayName from '../../../../../../helpers/displayName';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { HazRadioGroup, OptionsCheckboxes } from '../../ReduxForm/index';
import { CheckboxUnlabeled } from '../../../../../../common/components/ReduxFormField/index';
import './styles/TabContent.scss';

const META = 'data.attributes.metadata';

export class TravellersOptionsTab02 extends Component {
  constructor(props) {
    super(props);
    this.transformDocLinks = this.transformDocLinks.bind(this);
  }

  componentDidMount() {
    const { dispatch, change } = this.props;
    dispatch(change('data.current_tab', 2));
  }

  handleSelectActivitiesChange(activities) {
    const { dispatch, change } = this.props;
    if (activities && Array.isArray(activities)) {
      const maxCat = activities.reduce((carry, activity) => {
        return activity.attributes.category > carry
          ? activity.attributes.category
          : carry;
      }, 'A');

      dispatch(change(`${META}.options.hazardous_activities`, maxCat));
    } else {
      dispatch(change(`${META}.options.hazardous_activities`, 'A'));
    }
  }
  componentWillReceiveProps(newProps) {
    const { dispatch, change } = this.props;
    // If user uncheck the Cruiser checkbox
    const cruiseValue = get(newProps.formValues, `${META}.options.cruise_cover`);
    const cruiseValueOld = get(this.props.formValues, `${META}.options.cruise_cover`);
    if (cruiseValue !== true && cruiseValue !== cruiseValueOld) {
      confirm('Warning', {
        description:
          'You are about to remove the Cruise option from your quote. Would you like to continue?',
        close: () => {
          dispatch(change(`${META}.options.cruise_cover`, true));
        },
      });
    }

    const adults = get(newProps.formValues, `${META}.adults`);
    const children = get(newProps.formValues, `${META}.children`);

    const winter_sports_adult = reduce(
      adults,
      (winter_sport_exists, adult) => {
        return !!get(adult, 'metadata.options.winter_sports');
      },
      false,
    );

    const winter_sports_child = reduce(
      children,
      (winter_sport_exists, child) => {
        return !!get(child, 'metadata.options.winter_sports');
      },
      false,
    );
    const winter_sports = winter_sports_adult || winter_sports_child;

    // Used for Healix calculation when there is a winter sports selected
    if (
      get(newProps.formValues, 'data.attributes.metadata.options.winter_sports') !==
      winter_sports
    ) {
      dispatch(change(`${META}.options.winter_sports`, winter_sports));
    }

    // Dispatch individualOptionsSelected to display as Additional Cover in SideBar

    const adultOptions = map(adults, (adult) => {
      return adult && adult.metadata && adult.metadata.options;
    });

    const selectedOptions = map(adultOptions, (adult) => {
      const selected = map(keys(adult), (option) => {
        if (adult[option] === true) {
          return option;
        }
      });
      return compact(selected);
    });

    const selectedOptionsFlatten = flattenDeep(selectedOptions);
    const selectedOptionsUniq = uniqWith(selectedOptionsFlatten, isEqual);
    dispatch(change(`${META}.storage.individualOptionsSelected`, selectedOptionsUniq));
  }

  transformDocLinks(url) {
    const { currentProduct } = this.props;
    const documents = currentProduct.data.attributes.documents;
    if (url === 'hazardous_activities') {
      return documents['Information'];
    }
    return url;
  }

  // mapToReactSelect(options) {
  //   return map(options, (name, key) => {
  //     return {
  //       label: name,
  //       value: key,
  //     };
  //   });
  // }

  render() {
    const { currentProduct, formValues, renderDefinitions } = this.props;
    const numberOfAdults = get(formValues, 'data.attributes.metadata.adults.length', 0);
    const childrenDisabledOptions = ['business_equipment'];
    const numberOfChildren = get(
      formValues,
      'data.attributes.metadata.children.length',
      0,
    );
    const options = get(currentProduct, `${META}.options`, {});
    // const medicalExcess = this.mapToReactSelect(
    //   get(currentProduct, `${META}.medical_excess`, []),
    // );
    // const cancellationCover = this.mapToReactSelect(
    //   get(currentProduct, `${META}.cancellation_cover`, []),
    // );
    // const cancellationExcess = this.mapToReactSelect(
    //   get(currentProduct, `${META}.cancellation_excess`, []),
    // );
    // const baggageCover = this.mapToReactSelect(
    //   get(currentProduct, `${META}.baggage_cover`, []),
    // );
    // const baggageExcess = this.mapToReactSelect(
    //   get(currentProduct, `${META}.baggage_excess`, []),
    // );
    // excluding the individual options that will not be displayed in the Policy Options
    const excludedOptions = [
      'winter_sports',
      'golf_cover',
      'business_equipment',
      'hazardous_activities',
      'travel_dispute',
      'end_supplier',
      'smart_luggage',
      'cruise_cover',
    ];
    const excludedIndividual = ['cruise_cover', 'wedding_cover'];

    // const hasCoverOptions = () => {
    //   return (
    //     medicalExcess.length > 0 ||
    //     cancellationCover.length > 0 ||
    //     cancellationExcess.length > 0 ||
    //     baggageCover.length > 0 ||
    //     baggageExcess > 0
    //   );
    // };

    return (
      <div>
        <Row>
          <Col sm={12}>
            <h4 className="margin-bottom">Policy Options</h4>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Field
              component={HazRadioGroup}
              renderDefinitions={renderDefinitions}
              name={'data.attributes.metadata.options.hazardous_activities'}
              options={[
                { label: 'Hazardous Activities A', value: 'A' },
                { label: 'Hazardous Activities B', value: 'B' },
              ]}
            />
          </Col>
          <Col sm={6}>
            {Object.keys(get(currentProduct, 'data.attributes.metadata.options', {})).map(
              (option, i) => {
                if (indexOf(excludedOptions, option) === -1) {
                  return (
                    <div key={i}>
                      <Field
                        component={OptionsCheckboxes}
                        infoButton={renderDefinitions(`${option}`)}
                        name={'data.attributes.metadata.options.' + option}
                        options={[{ label: displayName(option), value: true }]}
                      />
                    </div>
                  );
                }
              },
            )}
          </Col>
        </Row>
        {/*<Row>*/}
        {/*  <Col sm={12}>*/}
        {/*    <ControlLabel>*/}
        {/*      Alternatively start typing an activity name and select any activities that*/}
        {/*      require cover below to help you find the appropriate level of Hazardous*/}
        {/*      Activity cover.*/}
        {/*    </ControlLabel>*/}
        {/*  </Col>*/}
        {/*</Row>*/}
        {/*<Row>*/}
        {/*  <Col sm={12}>*/}
        {/*    <ControlLabel>Activities</ControlLabel>*/}
        {/*  </Col>*/}
        {/*</Row>*/}
        {/*<Row>*/}
        {/*  <Col sm={12}>*/}
        {/*    <Field*/}
        {/*      component={SelectActivities}*/}
        {/*      placeholder="Search for activities..."*/}
        {/*      name="data.attributes.metadata.activities"*/}
        {/*      onChange={(e, values) => this.handleSelectActivitiesChange(values)}*/}
        {/*    />*/}
        {/*  </Col>*/}
        {/*</Row>*/}

        <Row className={'individual-options-title'}>
          <Col sm={12}>
            <h4 className="margin-bottom">Individual Options</h4>
          </Col>
        </Row>
        <Row>
          <Col sm={2}>
            <div className="traveller-title">Traveller</div>
          </Col>
          <Col sm={10}>
            <div className={'traveler-options-lists'}>
              {times(numberOfAdults + numberOfChildren, (i) => {
                const type = i < numberOfAdults ? 'adults' : 'children';
                const typeKey = type === 'children' ? i - numberOfAdults : i;
                return (
                  <div key={i} className="individual-options-traveller">
                    <div className="label-number">{i + 1}</div>
                    <div className="label-number">
                      {'(' +
                        get(
                          formValues,
                          `data.attributes.metadata.${type}[${typeKey}].age`,
                        ) +
                        ')'}
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>

        {map(options, (option, key) => {
          if (indexOf(excludedIndividual, key) === -1) {
            return (
              <Row key={key}>
                <Col sm={3}>
                  {renderDefinitions(`${key}`)}
                  {option.name}
                </Col>
                <Col sm={9}>
                  <div className={'traveler-options-lists'}>
                    {times(numberOfAdults + numberOfChildren, (i) => {
                      const type = i < numberOfAdults ? 'adults' : 'children';
                      const typeKey = type === 'children' ? i - numberOfAdults : i;
                      if (indexOf(excludedIndividual, key) === -1) {
                        return (
                          <div key={i} className={'individual-options-checkbox'}>
                            <Field
                              component={CheckboxUnlabeled}
                              options={[{ label: '', value: true }]}
                              disabled={
                                type === 'children' &&
                                includes(childrenDisabledOptions, key)
                              }
                              name={`data.attributes.metadata.${type}[${typeKey}].metadata.options.${key}`}
                            />
                          </div>
                        );
                      }
                    })}
                  </div>
                </Col>
              </Row>
            );
          }
        })}

        <div className="divider margin-bottom" />
      </div>
    );
  }
}

const FORM_NAME = 'LeisureTravelForm';
const form = reduxForm({ form: FORM_NAME })(TravellersOptionsTab02);
const selector = formValueSelector(FORM_NAME);
const mapStateToProps = (state, props) => {
  const values = selector(state, 'data.id', 'data.attributes.metadata');

  return {
    auth: state.auth,
    formValues: values,
    product: state.product,
    destroyOnUnmount: false,
    form: 'LeisureTravelForm',
    initialValues: props.resource,
    forceUnregisterOnUnmount: true,
  };
};

export default connect(mapStateToProps)(form);
